var map = {
	"./icon-01.png": "REDb",
	"./icon-02.png": "wZFc",
	"./icon-03.png": "yVxx",
	"./icon-04.png": "HU3A"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ijT";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/how-to-books ^\.\/.*$
// module id = 4ijT
// module chunks = 1